import { render, staticRenderFns } from "./QuestionBlock.vue?vue&type=template&id=49f8a9f2&scoped=true"
import script from "./QuestionBlock.vue?vue&type=script&lang=js"
export * from "./QuestionBlock.vue?vue&type=script&lang=js"
import style0 from "./QuestionBlock.vue?vue&type=style&index=0&id=49f8a9f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8a9f2",
  null
  
)

export default component.exports